import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as routeBound from '../../../route-bound'

import * as me from '../../../me'

import { Api } from './api.service'
import type { TypeParams } from './types'

/**
 * Persons collection for fetching space persons — lite space variant.
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: person => person.id,
      name: ec.Name.Predefined.SpacePeopleLite,
    })
  }
}
